import { observable, action, makeObservable } from "mobx";
import axios from "common/axios";
const typeInterface = {
  StoresList: "/biz/shop/list",
  ShippingMethod: "/biz/logistics/list",
};
class List {
  constructor() {
    makeObservable(this);
  }
  @observable dataList = {
    StoresList: [],
    ShippingMethod: [],
  };

  @action
  queryLists = async (type) => {
    const { code, body } = await axios.get(typeInterface[type], {
      params: {
        pageNo: 1,
        pageSize: 100,
      },
    });
    let StoresList = [];
    if (code === 200) {
      StoresList = body?.map((td) => ({
        ...td,
        label:
          td.shopName ||
          (type&&type === "ShippingMethod" ? (td.cname + `(${td.code})`) :  (sessionStorage.getItem("i18nLang") === "zh" ? td.cname : td.ename)),
        value: td.id,
      }));
    }
    this.dataList = {
      ...this.dataList,
      [type]: StoresList,
    };
  };
}
export default new List();
